<template>
  <div class="course-container">
    <div class="filter-section">
      <img
        src="https://res.hangxintong.cn/nxjpWx/icon/gk-zx.png"
        class="filter-logo"
      />
      <div v-if="userStore.getUserInfo" class="cart-section">
        <div class="cart-btn" @click="router.push('/cart')">
          <SvgIcon name="cart-orange" size="15" class="cart-icon" />
          购物车（{{ cartCount || 0 }}）
        </div>
      </div>
    </div>
    <div class="filter-classification">
      <div
        class="gong"
        style="background: #fff; display: flex; align-items: center"
      >
        <div class="supervisor" style="margin-top: -4px">商品名称</div>
        <div style="margin-left: 10px">
          <el-input
            v-model.trim="queryForm.name"
            style="width: 380px"
            clearable
            placeholder="请输入商品名称查询"
          />
          <el-button
            type="primary"
            style="
              margin-left: 12px;
              background: #3c99ff;
              border: 1px solid #3c99ff;
            "
            @click="queryName"
          >
            查询
          </el-button>
        </div>
      </div>
      <div class="competentAuthority gong">
        <div class="supervisor">主管部门</div>
        <div class="filter-items">
          <div
            v-for="(item, index) in competentAuthority"
            :key="index"
            :class="
              item.id == queryForm.manageDeptId
                ? 'selected-item'
                : 'filter-item'
            "
            @click="addthority(1, item)"
          >
            {{ item.name || '--' }}
          </div>
        </div>
      </div>
      <div class="NewExamContinuation gong">
        <div class="supervisor">新考/继续</div>
        <div class="filter-items">
          <div
            v-for="(item, index) in NewExamContinuation"
            :key="index"
            :class="item.id == parentId ? 'selected-item' : 'filter-item'"
            @click="addthority(2, item)"
          >
            {{ item.name || '--' }}
          </div>
        </div>
      </div>
      <div class="CourseClassification gong" v-loading="ClassLOading">
        <div class="supervisor" style="display: flex"> 课程分类</div>
        <div style="display: flex">
          <div
            :class="
              queryForm.categoryId == '' ||
              queryForm.categoryId == 1 ||
              queryForm.categoryId == 2
                ? 'selected-item'
                : 'filter-item'
            "
            @click="addthority(3, '')"
            style="flex-shrink: 0"
          >
            全部
          </div>
          <div class="filter-items">
            <div
              v-for="(item, index) in CourseClassification"
              :key="index"
              :class="
                item.id == queryForm.categoryId
                  ? 'selected-item'
                  : 'filter-item'
              "
              @click="addthority(3, item)"
            >
              {{ item.name || '--' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="background: #fff">
      <div class="course-grid" v-loading="loading">
        <div
          v-for="(item, index) in courseList"
          :key="index"
          class="course-card"
          @click="toInfoXq(item)"
        >
          <div class="course-content">
            <div class="course-title">
              {{ item.name }}
            </div>
            <div class="tagsbox">
              <div class="course-tags">
                <div class="course-tag">
                  {{ item.manageDeptName || '' }}
                </div>
                <div class="course-tag">
                  {{ item.categoryName || '' }}
                </div>
                <div class="course-tag">
                  {{
                    item.categoryType == 1
                      ? '新考课程'
                      : item.categoryType == 2
                      ? '继续教育'
                      : ''
                  }}
                </div>
              </div>
              <div class="course-tags" v-if="item.year">
                <div class="course-tag">
                  {{ item.year || '' }}
                </div>
              </div>
            </div>
            <div class="course-footer">
              <div class="price-section"> ￥ {{ item.price }}</div>
              <div class="buy-btn" @click.stop="addCart(item)"> 选购课程</div>
            </div>
          </div>
        </div>
        <div style="margin: 0 auto" v-if="!courseList.length">
          <el-empty
            style="margin-top: 50px"
            description="暂无课程"
            :image-size="100"
            image="https://res.hangxintong.cn/uniXkb/status/s3.png"
          />
        </div>
      </div>
      <div class="pagination-section">
        <div>
          共
          <span style="color: #1677ff">{{ total || 0 }}</span>
          条
        </div>
        <el-pagination
          v-model:page-size="queryForm.pageSize"
          v-model:current-page="queryForm.pageNum"
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!--    购课-->
    <el-dialog
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      v-model="addCartDialog"
      title="购课"
      width="550"
    >
      <div>
        <img
          src="https://res.hangxintong.cn/nxjpWx/icon/xk-kc.png"
          alt=""
          v-if="currentCourse.categoryType == 1"
          style="width: 152px; height: 44px; margin-top: 10px"
        />
        <img
          src="https://res.hangxintong.cn/nxjpWx/icon/jx-jy.png"
          alt=""
          v-if="currentCourse.categoryType == 2"
          style="width: 152px; height: 44px; margin-top: 10px"
        />
        <div class="dialog-title">{{ currentCourse.name }}</div>
        <span class="dialog-categoryName" v-if="currentCourse.year">
          {{ currentCourse.year }}
        </span>
        <span
          class="dialog-categoryName"
          style="margin-left: 12px"
          v-if="currentCourse.manageDeptName"
        >
          {{ currentCourse.manageDeptName }}
        </span>
        <span
          class="dialog-categoryName"
          v-if="currentCourse.categoryName"
          style="margin-left: 12px"
        >
          {{ currentCourse.categoryName }}
        </span>
        <div style="height: 20px"></div>
      </div>
      <template #footer>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="danjias">
            单价：<span class="yis">￥</span
            ><span>{{ currentCourse.price || 0 }}</span>
          </div>
          <div>
            <el-button
              color="#FF5F38"
              style="width: 138px; height: 40px; font-size: 15px"
              plain
              @click="addToCart(currentCourse)"
            >
              <el-icon style="font-size: 21px">
                <ShoppingCart />
              </el-icon>
              &nbsp;为他人购买
            </el-button>
            <el-button
              color="#FF5F38"
              style="width: 138px; height: 40px; font-size: 15px; color: #fff"
              @click="toInfo(currentCourse)"
            >
              <el-icon style="font-size: 21px">
                <User />
              </el-icon>
              &nbsp;为自己购买
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <!--    继续购买-->
    <el-dialog
      v-model="showRepeatTip"
      title="提示"
      width="480"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content">
        <div
          class="dialog-text"
          style="display: flex; align-items: center; margin-top: 10px"
        >
          <el-icon color="#FF8B00">
            <WarningFilled />
          </el-icon>
          该商品不支持重复购买
        </div>
        <div class="dialog-text">您已购买过该商品，不能重复购买！</div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <!--          <el-button type="primary" @click="continuePay(listItem)"-->
          <!--            >继续购买-->
          <!--          </el-button>-->
          <el-button plain @click="bin"> 取消</el-button>
        </div>
      </template>
    </el-dialog>
    <!--    系统提示-->
    <el-dialog
      v-model="SystemPrompt"
      title="系统提示"
      width="480"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-content">
        <div
          style="
            color: #2c3242;
            font-weight: 400;
            font-size: 14px;
            display: flex;
            align-items: center;
          "
        >
          <el-icon color="#04B578">
            <Warning />
          </el-icon>
          &nbsp;加入购物车成功
        </div>
        <div
          style="
            color: #2c3242;
            font-weight: 500;
            font-size: 16px;
            margin-left: 15px;
            margin-top: 8px;
          "
        >
          您为他人购买的课程已成功加入购物车！
        </div>
        <div
          style="
            color: #2c3242;
            font-weight: 500;
            font-size: 15px;
            margin-left: 15px;
            margin-top: 8px;
          "
        >
          课程名称：{{ currentCourse.name }}
        </div>
      </div>
      <template #footer>
        <div
          style="display: flex; align-items: center; justify-content: center"
        >
          <el-button @click="SystemPrompt = false"> 继续选课</el-button>
          <el-button
            style="background: #ff511f; color: #fff; border: none"
            @click="router.push('/cart')"
          >
            去购物车结算
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ElMessage } from 'element-plus'
import {
  courseListApi,
  getTagListApi,
  courseFilterListApi,
  manageDeptApi,
  productApi,
  pageListApi,
  getTrainCourseInfoApi,
  getPurchasedStateApi,
} from '@/api/course'
import { shoppingCarList, shoppingCarPost } from '@/api/ShoppingCart'
import mitt from 'mitt'
import { useUserStore } from '@/store/modules/user'
import { getCourseCheckFormApi } from '@/api/learn'
import { postFormData } from '@/api/FormApi'
import { createOrderApi } from '@/api/order'

const SystemPrompt = ref(false)
const courseInfo = ref('')
const userStore = useUserStore()
// 使用全局事件总线
const emitter = window.emitter
const competentAuthority = ref([{ id: '', name: '全部' }])
const NewExamContinuation = ref([
  { id: '', name: '全部' },
  { id: 1, name: '新考课程' },
  { id: 2, name: '继续教育' },
])
const CourseClassification = ref([])
const router = useRouter()
const route = useRoute()
const total = ref(0)
const queryForm = reactive({
  pageNum: 1,
  pageSize: 10,
  manageDeptId: '', //部门id
  categoryId: '', //分类id
  name: '',
})
const loading = ref(false)
const cateName = ref('')
const categoryList = ref([]) // 父级分类
// 课程列表
const courseList = ref([])
const cartCount = ref(0)
const ClassLOading = ref(false)
const isRepeat = ref(true)
const showRepeatTip = ref(false) // 重复购买提示
const listItem = ref('')
const parentId = ref('')

// 监听 userStore.getUserInfo 变化
watch(
  () => userStore.getUserInfo,
  newVal => {
    if (newVal) {
      console.log('userStore.getUserInfo changed, calling shoppingCarListFun')
      shoppingCarListFun()
    }
  },
  { immediate: true }
)

onMounted(() => {
  if (route.query.pageNum) {
    queryForm.pageNum = +route.query.pageNum
  }
  if (route.query.manageDeptId) {
    queryForm.manageDeptId = route.query.manageDeptId
  }
  if (route.query.name) {
    queryForm.name = route.query.name
  }
  if (route.query.parentId) {
    parentId.value = route.query.parentId
    // queryForm.categoryId = route.query.parentId
  }
  if (route.query.categoryId) {
    queryForm.categoryId = route.query.categoryId
  }
  manageDeptApiFun()
  productApiFun(parentId.value)
  getList()
})

function queryName() {
  queryForm.pageNum = 1
  // queryForm.manageDeptId = ''
  // queryForm.categoryId = ''
  let newUrl =
    window.location.pathname +
    '?pageNum=' +
    queryForm.pageNum +
    '&manageDeptId=' +
    queryForm.manageDeptId +
    '&categoryId=' +
    queryForm.categoryId +
    '&parentId=' +
    parentId.value
  window.history.pushState(
    { pageNum: queryForm.pageNum },
    'pageNum' + queryForm.pageNum,
    newUrl
  )
  getList()
}

function bin() {
  showRepeatTip.value = false
  addCartDialog.value = false
}

//添加筛选
function addthority(type, item) {
  if (type == 1) {
    queryForm.manageDeptId = item.id
    queryForm.categoryId = ''
    parentId.value = ''
    productApiFun('')
  } else if (type == 2) {
    parentId.value = item.id
    queryForm.categoryId = item.id
    productApiFun(item.id)
  } else if (type == 3) {
    parentId.value = item.parentId
    queryForm.categoryId = item.id || ''
  }
  let newUrl =
    window.location.pathname +
    '?pageNum=' +
    queryForm.pageNum +
    '&manageDeptId=' +
    queryForm.manageDeptId +
    '&categoryId=' +
    queryForm.categoryId +
    '&parentId=' +
    parentId.value
  window.history.pushState(
    { pageNum: queryForm.pageNum },
    'pageNum' + queryForm.pageNum,
    newUrl
  )
  getList()
}

//部门
function manageDeptApiFun() {
  competentAuthority.value = [{ id: '', name: '全部' }]
  manageDeptApi().then(res => {
    competentAuthority.value = [...competentAuthority.value, ...res.data]
  })
}

//分类
function productApiFun(parentId) {
  ClassLOading.value = true
  // CourseClassification.value = [{ id: '', name: '全部' }]
  productApi(parentId)
    .then(res => {
      CourseClassification.value = res.data
      ClassLOading.value = false
    })
    .catch(() => {
      ClassLOading.value = false
    })
}

function shoppingCarListFun() {
  shoppingCarList().then(res => {
    cartCount.value = res.data.list.length
    console.log('res22222222222', res)
    // 通过全局事件总线发送购物车数量
    emitter.emit('cartCountUpdate', res.data.list.length)
    // 存储到 localStorage 以便其他页面获取
    localStorage.setItem('cartCount', res.data.list.length)
  })
}

//加入购物车
function addToCart(item) {
  console.log(item)
  let data = {
    goodsId: item.id, //商品id
    goodsClassId: item.categoryId, //分类id
    unitPrice: item.price, //单价
    quantity: 1, //数量
  }
  shoppingCarPost(data).then(res => {
    console.log(res, 'resresres')
    if (res.code == 1000) {
      shoppingCarListFun()
      addCartDialog.value = false
      // SystemPrompt.value = true
      ElMessage.success('该课程已添加购物车')
    }
  })
}

function handleCategory(data) {
  // console.log(data)
  // console.log(categoryList.value)
  if (data == null) {
    queryForm.categoryId = ''
  }
  cateName.value = guigui(categoryList.value, data == null ? '' : data)
  queryForm.pageNum = 1
  let newUrl =
    window.location.pathname +
    '?pageNum=' +
    queryForm.pageNum +
    '&manageDeptId=' +
    queryForm.manageDeptId +
    '&categoryId=' +
    queryForm.categoryId +
    '&parentId=' +
    parentId.value
  window.history.pushState(
    { pageNum: queryForm.pageNum },
    'pageNum' + queryForm.pageNum,
    newUrl
  )
  getList()
}

function guigui(data, id) {
  // console.log(data, id)
  for (let i = 0; i < data.length; i++) {
    if (data[i].id == id) {
      return data[i].label
    }
    if (data[i].children && data[i].children.length > 0) {
      return guigui(data[i].children, id)
    }
  }
}

// function handleTree(data, id, parentId, children) {
//   let config = {
//     id: id || 'id',
//     parentId: parentId || 'parentId',
//     childrenList: children || 'children',
//   }
//   var childrenListMap = {}
//   var nodeIds = {}
//   var tree = []
//   for (let d of data) {
//     let parentId = d[config.parentId]
//     if (childrenListMap[parentId] == null) {
//       childrenListMap[parentId] = []
//     }
//     nodeIds[d[config.id]] = d
//     childrenListMap[parentId].push(d)
//   }
//   for (let d of data) {
//     let parentId = d[config.parentId]
//     if (nodeIds[parentId] == null) {
//       tree.push(d)
//     }
//   }
//   for (let t of tree) {
//     adaptToChildrenList(t)
//   }
//   function adaptToChildrenList(o) {
//     if (childrenListMap[o[config.id]] !== null) {
//       o[config.childrenList] = childrenListMap[o[config.id]]
//     }
//     if (o[config.childrenList]) {
//       for (let c of o[config.childrenList]) {
//         adaptToChildrenList(c)
//       }
//     }
//   }
//   return tree
// }

// 获取课程列表
function getList() {
  loading.value = true
  pageListApi(queryForm)
    .then(res => {
      // 列表数据
      courseList.value = res.data.list
      // 总页数
      total.value = res.data.total
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

function handleCurrentChange(currentPage) {
  queryForm.pageNum = currentPage
  // 切换路由把参数传到地址栏里
  let newUrl =
    window.location.pathname +
    '?pageNum=' +
    queryForm.pageNum +
    '&manageDeptId=' +
    queryForm.manageDeptId +
    '&categoryId=' +
    queryForm.categoryId +
    '&parentId=' +
    parentId.value
  window.history.pushState(
    { pageNum: queryForm.pageNum },
    'pageNum' + queryForm.pageNum,
    newUrl
  )
  getList()
}

//详情
function toInfoXq(item) {
  router.push('/course/courseInfo/' + item.id)
}

//为自己购买
function toInfo(item) {
  listItem.value = item
  getTrainCourseInfo(item.id)
}

// 课程简介
function getTrainCourseInfo(id) {
  getTrainCourseInfoApi(id).then(res => {
    courseInfo.value = res.data
    getPurchasedStateApi(id).then(res => {
      isRepeat.value = res.data
      if (!isRepeat.value) {
        // 重复报名
        showRepeatTip.value = true
        addCartDialog.value = false
        return
      } else {
        showRepeatTip.value = false
        // 查询表单
        const data = {
          resourceType: 'product', //exam
          resourceId: id,
        }
        getCourseCheckFormApi(data).then(res => {
          showRepeatTip.value = false
          if (res.data.needFill) {
            // 报名需要填写表单
            router.push(
              `/CustomerForm/index?FormId=${res.data.formId}&type=product&resourceId=${id}`
            )
          } else {
            // router.push('/placeOrder?id=' + id + '&enrollId=' + '')
            const courseObj = {
              productId: id,
              num: 1,
              orderScene: 'purchaseCourse',
              enrollId: '',
            }
            createOrderApi(courseObj).then(res => {
              router.push('/orderDetail?id=' + res.data.id)
            })
          }
        })
      }
    })
    // .catch(err => {
    //   console.log(err)
    //   loading.value = false
    // })
  })
}

// 重复购买 继续购买
// function continuePay(item) {
//   // 查询表单
//   const data = {
//     resourceType: 'prodoct', //exam
//     resourceId: item.id,
//   }
//   getCourseCheckFormApi(data).then(res => {
//     showRepeatTip.value = false
//     if (res.data.needFill) {
//       // 报名需要填写表单
//       router.push(
//         `/CustomerForm/index?FormId=${res.data.formId}&type=prodoct&resourceId=${item.id}`
//       )
//     } else {
//       // const data = {
//       //   resourceType: 'prodoct',
//       //   productId: item.id,
//       // }
//       // postFormData(data).then(res => {
//       //   if (res.code == 1000) {
//       router.push('/placeOrder?id=' + item.id + '&enrollId=' + '')
//       //   } else {
//       //     ElMessage({ message: res.msg, type: 'error' })
//       //   }
//       // })
//     }
//     // }
//   })
// }

// 弹窗 加入购物车
const addCartDialog = ref(false)
const currentCourse = ref({})

function addCart(item) {
  console.log(item)
  if (!userStore.getToken) {
    userStore.setShowLogin(true)
    return
  }
  // router.push('/cart')
  addCartDialog.value = true
  currentCourse.value = item
}
</script>

<style scoped lang="scss">
.el-input__wrapper {
  background: #ebebeb !important;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  margin-left: 20px;
  margin-bottom: 13px;
  padding: 12px 16px;
}

.dialog-text {
  color: #333;
  font-size: 14px;
  margin-left: 10px;
}

/* 对话框 */
.dialog-content {
  margin: 0 22px;
  padding: 12px 16px;
}

.danjias {
  font-family: PingFangSC-regular;
  color: #6d6d6d;
  font-weight: 400;
  font-size: 14px;

  span {
    font-family: DINAlternate-Bold;
    color: #ff511f;
    font-weight: 700;
    font-size: 26px;
  }

  .yis {
    font-size: 16px;
  }
}

.dialog-categoryName {
  background: #f2f5f8;
  border-radius: 4px;
  color: #6f7680;
  padding: 5px 20px;
  min-height: 516px;
}

.filter-butt {
  font-family: PingFangSC-medium;
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
  padding: 5px 10px;
  background: #2d9fff;
  border-radius: 4px;
  margin-right: 8px;
}

.supervisor {
  width: 80px;
  flex-shrink: 0;
  font-family: PingFangSC-regular;
  color: #000000;
  font-weight: 500;
  font-size: 15px;
}

.gong {
  background: #f9fafd;
  padding: 9px;
  margin: 8px 0;
  border-radius: 4px;
  display: flex;
}

.filter-classification {
  background: #fff;
  padding: 20px 30px;
  margin-bottom: 12px;
}

// 主容器
.course-container {
  width: 1360px;
  margin: 0 auto;
}

// 筛选区域
.filter-section {
  padding: 13px 24px;
  margin: 12px 0;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-left {
  display: flex;
  align-items: center;
}

.search-section {
  // 保持原有样式
}

.cart-section {
  // 保持原有样式
}

.cart-icon {
  margin-right: 9px;
}

// 标签区域
.tag-section {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  margin-top: 20px;
  margin-bottom: 12px;
  padding: 20px 24px;
  gap: 10px;
}

.tag-list {
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.class-item {
  padding: 7px 24px;
  background-color: #f3f3f3;
  color: #757576;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;

  &:hover {
    background-color: #f0f6ff;
    color: #166af7;
  }
}

.active-tag {
  color: #fff;
  background-color: #166af7;
}

// 分类标题
.category-title {
  font-size: 26px;
  color: #3e454d;
  margin: 20px 0;
}

// 课程网格
.course-grid {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 16px 20px;
  background: #fff;
  padding: 16px;
  margin-bottom: 20px;
  align-content: flex-start; /* 内容从顶部开始排列，避免纵向分散 */
  align-items: flex-start; /* 子项顶部对齐，避免纵向居中导致的留白 */
  height: 450px;
  overflow: auto;
}

// 课程卡片
.course-card {
  width: 245px;
  height: 210px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background: #f6f7f8;
  border-radius: 4px;

  &:hover {
    box-shadow: 0 5px 10px 2px #e4e4e4;
  }
}

.course-image {
  width: 100%;
  height: 184px;
}

.course-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px 12px;
  overflow: hidden;
}

.course-title {
  font-family: AlimamaShuHeiTi-Bold;
  color: #2c3242;
  font-weight: 500;
  font-size: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 50px;
}

.tagsbox {
  flex: 1;
}

.course-tags {
  display: flex;
  flex-wrap: wrap;
}

.course-tag {
  padding: 4px 8px;
  flex-shrink: 0;
  margin-right: 3px;
  margin-top: 5px;
  background: #fff;
  border-radius: 4px;
  font-family: PingFangSC-regular;
  color: #626e82;
  font-weight: 400;
  font-size: 11px;
  max-width: 200px;
  white-space: nowrap;
  /* 2. 超出容器的部分隐藏 */
  overflow: hidden;
  /* 3. 超出部分显示省略号 */
  text-overflow: ellipsis;
}

.popover-tags {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.popover-tag {
  font-size: 14px;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.course-footer {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 12px;
}

.price-section {
  font-family: PingFangSC-medium;
  color: #000000;
  font-weight: 500;
  font-size: 16px;
}

.price {
  font-size: 16px;
  font-weight: 500;
  color: #000;
}

.currency {
  font-size: 16px;
}

// 分页区域
.pagination-section {
  display: flex;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 95%;
  margin: 0 auto;
  padding-bottom: 20px;
  margin-top: -20px;
  margin-bottom: 20px;
}

// 对话框样式
.dialog-category {
  font-size: 16px;
  color: #3e454d;
  margin-bottom: 8px;
}

.dialog-title {
  font-family: PingFangSC-medium;
  color: #2c3242;
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 12px;
  margin-left: 6px;
  margin-bottom: 12px;
}

.dialog-info {
  font-size: 14px;
  color: #999999;
  margin-bottom: 12px;
  margin-top: 12px;
}

.dialog-tags {
  height: 27px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px 6px;
}

.dialog-tag {
  font-size: 14px;
  padding: 4px 14px;
  border-radius: 20px;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dialog-popover-tags {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-popover-tag {
  font-size: 14px;
  padding: 4px 14px;
  border-radius: 20px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 筛选区域样式 */
.filter-logo {
  width: 146px;
  height: 36px;
}

.filter-items {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1px;
}

.selected-item {
  margin: 0 10px;
  font-family: PingFangSC-regular;
  color: #0076f6;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 10px;
  cursor: pointer;
  background: #e5f4ff;
  border-radius: 2px;
  height: 23px;
}

.filter-item {
  margin: 0 10px;
  font-family: PingFangSC-regular;
  color: #5e5e5e;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 10px;
  cursor: pointer;
  height: 23px;
}

/* 对话框样式 */
.dialog-icon {
  height: 50px;
}

.dialog-buy-btn {
  color: #fff;
}

:deep(.el-input-group__append) {
  background-color: #0060ef;
  color: #fff;
  cursor: pointer;
}

.buy-btn {
  /* 矩形 */
  width: 88px;
  height: 28px;
  border-radius: 14px;
  background-color: #fff4f3;
  border: 1px solid #ff5f4d;
  color: #ff5f4d;
  font-size: 14px;
  text-align: center;
  line-height: 28px;
}

.cart-btn {
  /* 矩形 */
  min-width: 120px;
  height: 32px;
  border-radius: 4px;
  background-color: #fffaf9;
  border: 1px solid #ff4200;
  color: #ff4200;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
}
</style>
